/* Simple tab switcher.
   Markup (within a common parent):
     <div data-tabs> <button data-tab="0">..</button> ... </div>
     <div data-panel="0">..</div> <div data-panel="1" hidden>..</div> ...
   Showing a panel dispatches cp:carousel:init so any carousel inside it
   (which couldn't measure itself while hidden) starts up. */
(function () {
  'use strict';

  function initTabs(tabsEl) {
    if (tabsEl.dataset.tabsReady === 'true') return;
    tabsEl.dataset.tabsReady = 'true';

    var scope = tabsEl.parentElement || document;
    var buttons = tabsEl.querySelectorAll('[data-tab]');

    function activate(index) {
      buttons.forEach(function (btn) {
        var on = btn.getAttribute('data-tab') === String(index);
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      scope.querySelectorAll('[data-panel]').forEach(function (panel) {
        if (panel.getAttribute('data-panel') === String(index)) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });
      // Let carousels in the now-visible panel initialise / start autoplay.
      document.dispatchEvent(new Event('cp:carousel:init'));
      // Trigger Judge.me reviews widget refresh if present
      if (window.jdgm) {
        try {
          if (typeof window.jdgm.renderReviewWidget === 'function') window.jdgm.renderReviewWidget();
          else if (typeof window.jdgm.renderWidgets === 'function') window.jdgm.renderWidgets();
          else if (typeof window.jdgm.init === 'function') window.jdgm.init();
        } catch (err) {}
      }
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activate(btn.getAttribute('data-tab'));
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tabs]').forEach(initTabs);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);
})();
